import { makeVar } from '@apollo/client'
import { AccessToken, User } from 'types/user'

export const IsAuthenticated = makeVar<boolean>(false)
export const IsUserVerified = makeVar<boolean>(false)
export const CurrentToken = makeVar<string | undefined>(undefined)
export const CurrentUser = makeVar<User | undefined>(undefined)
export const CurrentAccessToken = makeVar<AccessToken | undefined>(undefined)
